module.exports = "<dynamic-expandable-table [showFilter]=\"false\"></dynamic-expandable-table>\n"